import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../../pages/Home";
import Promotion from "../../pages/Promotion";
import Blog from "../../pages/Blog";
import LiveCasino from "../../pages/LiveCasino";
import Slot from "../../pages/Slot";
import Sportbook from "../../pages/Sportbook";
import Card from "../../pages/Card";
import Fishing from "../../pages/Fishing";
import Keno from "../../pages/Keno";
import Menu from "../../pages/Menu";
import Login from "../../pages/Login";

const PageContent = ({ routeLocation }) => (
  <Routes location={routeLocation}>
    <Route path="/" element={<Navigate to="/login" replace />} />
    <Route path="/login" element={<Login />} />
    <Route path="/promotion" element={<Promotion />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/livecasino" element={<LiveCasino />} />
    <Route path="/slot" element={<Slot />} />
    <Route path="/sportbook" element={<Sportbook />} />
    <Route path="/card" element={<Card />} />
    <Route path="/keno" element={<Keno />} />
    <Route path="/fishing" element={<Fishing />} />
    <Route path="/lotto" element={<Navigate to="/keno" replace />} />
    <Route path="/menu" element={<Menu />} />
    <Route path="/home" element={<Home />} />
  </Routes>
);

export default PageContent;
